import { render, staticRenderFns } from "./BdRight.vue?vue&type=template&id=3e211e49&scoped=true&"
import script from "./BdRight.vue?vue&type=script&lang=js&"
export * from "./BdRight.vue?vue&type=script&lang=js&"
import style0 from "./BdRight.vue?vue&type=style&index=0&id=3e211e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e211e49",
  null
  
)

export default component.exports